import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../../slice'
import createStaffMembersSlice, {
  StaffMembersSlice,
} from './staff-members/slice'
import createEditStaffMemberSlice, {
  EditStaffMemberSlice,
} from './staff-members/edit/slice'
import createAddStaffMemberSlice, {
  AddStaffMemberSlice,
} from './staff-members/add/slice'
import createApprovalsSlice, { ApprovalsSlice } from './approvals/slice'
import createManageRequestSlice, {
  ManageRequestSlice,
} from './approvals/manage/slice'
import createSharedWorkforceSlice, { WorkforceSharedSlice } from './slice'

const useWorkforceStore = create<
  ManageRequestSlice &
    ApprovalsSlice &
    StaffMembersSlice &
    EditStaffMemberSlice &
    AddStaffMemberSlice &
    WorkforceSharedSlice &
    SharedSlice
>()((...props) => ({
  ...createSharedSlice(...props),
  ...createEditStaffMemberSlice(...props),
  ...createAddStaffMemberSlice(...props),
  ...createStaffMembersSlice(...props),
  ...createApprovalsSlice(...props),
  ...createManageRequestSlice(...props),
  ...createSharedWorkforceSlice(...props),
}))

export default useWorkforceStore
